export default "__VITE_ASSET__bR$JCRp5__"